module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4n6r9n-7ea766c41d562c7603e84192f4192bfa.svg";